module.exports = __webpack_public_path__ + "img/approvereq.39fc22da.svg";